export const rootArticleId = 'root-article';
export const rootArticleSlug = 'slug-root-article';

console.log('rootArticleId', rootArticleId);
